import { render, staticRenderFns } from "./TdStatus.vue?vue&type=template&id=c618129a&"
import script from "./TdStatus.vue?vue&type=script&lang=ts&"
export * from "./TdStatus.vue?vue&type=script&lang=ts&"
import style0 from "./TdStatus.vue?vue&type=style&index=0&id=c618129a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports